var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommonIconTrashFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "common_icon_trash_filled_svg__a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceGraphic",
    values: "0 0 0 0 0.054902 0 0 0 0 0.117647 0 0 0 0 0.070588 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#common_icon_trash_filled_svg__a)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.303 0a1.105 1.105 0 00-.786.313c-.21.204-.327.483-.327.774H2.614c-.396-.005-.765.2-.964.539-.2.339-.2.757 0 1.096.2.339.568.545.964.539h19.772c.396.006.765-.2.964-.539.2-.339.2-.757 0-1.096a1.101 1.101 0 00-.964-.539H15.81c0-.29-.117-.57-.327-.774A1.105 1.105 0 0014.697 0h-4.394zM2.614 5.435v17.391c0 1.201.983 2.174 2.197 2.174h15.378a2.185 2.185 0 002.197-2.174V5.435H2.614z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))));
}

export default SvgCommonIconTrashFilled;